<template>
  <div data-component="base-search-query-string-value">
    <base-search-query-labels
      :param="param"
      :schema="schema"
    />

    <span
      v-if="param.value"
      data-label="search-param-value"
      :title="param.value"
    >
      <span class="text">{{ param.value }}</span>

      <div
        data-button="delete-param"
        @click.stop="$emit('delete-param', param)"
      >
        <or-icon icon="close" />
      </div>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';

import BaseSearchQueryLabels from './BaseSearchQueryLabels.vue';
import { PARAM_PROP, SCHEMA_PROP } from '../../constants';

export default defineComponent({
  name: 'BaseSearchQueryStringValue',
  components: { BaseSearchQueryLabels, OrIcon },
  props: {
    param: PARAM_PROP,
    schema: SCHEMA_PROP,
  },
  emits: ['delete-param'],
});
</script>

<style lang="scss" scoped>
@use '../../styles' as *;

[data-component='base-search-query-string-value'] {
  @include base-search-query-tags;
}
</style>
